import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as userService from '_services/user-service';

const initialState = {
    reviewName: {},
    status: 'idle',
    error: null
};

// post a new tester //
export const getReviewName = createAsyncThunk('reviewName/getReviewName', async (reviewName) => {
    console.log('slice getting review name...')
    return userService.getUserName(reviewName);
});

const reviewNameSlice = createSlice({
    name: 'reviewName',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: {
        [getReviewName.pending]: (state, action) => {
            return {
              ...state,
              status: 'loading',
            }
        },
        [getReviewName.fulfilled]: (state, action) => {
            return {
              ...state,
              status: 'succeeded',
              reviewName: {
               ...state.reviewName,
               [action.payload.uid]: action.payload.displayName
              }
            }
        },
        [getReviewName.rejected]: (state, action) => {
            return {
              ...state,
              status: 'failed',
              error: action.error.message,
            }
        }
    }
});

export const { reset } = reviewNameSlice.actions;
export const selectReviewName = state => state.reviewName.reviewName;
export const selectReviewStatus = state => state.reviewName.status;
export default reviewNameSlice.reducer;
